<template>
  <div class="privacy-modal">
    <b-modal
      id="datasheet-privacy-modal"
      ok-only
      size="lg"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      <template slot="modal-header" class="mx-auto">
        <div>
          <h3>Observation Privacy</h3>
          <p class="mb-0">
            Who can view the observation responses after they are collected?
            Changing this will affect only future responses (NEW data). Existing
            observations will retain their original privacy settings.
          </p>
        </div>
      </template>
      <template slot="default">
        <b-form-radio-group v-model="isPrivate" stacked size="lg">
          <div v-if="projectPrivacy">
            <b-form-radio :value="false" class="my-2">
              <font-awesome-icon class="ml-2 mr-2" :icon="['fas', 'people-group']" size="2xl"/>
              <span class="h4">Members Only</span>
            </b-form-radio>
            <b-row class="ml-3 mb-2">
              <b-col class="ml-3" lg="11" sm="11">
                The public will not be able to see responses. All project members
                will be able to see responses. Individual questions within a
                datasheet can be set to private in a later step.
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <b-form-radio :value="false" class="my-2">
              <font-awesome-icon class="ml-2 mr-2" :icon="['fas', 'globe']" size="2xl"/>
              <span class="h4">Public</span>
            </b-form-radio>
            <b-row class="ml-3 mb-2">
              <b-col class="ml-3" lg="11" sm="11">
                Everyone, including non-members, will be able to see responses
                to this datasheet. Individual questions can be set to private.
              </b-col>
            </b-row>
          </div>
          <b-row class="ml-3 mb-4">
            <b-col class="ml-3" lg="11" sm="11">
              <b-form-checkbox v-model="cascadePublic" :disabled="isPrivate"
                >Also apply to all questions
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-form-radio :value="true" class="my-2">
            <font-awesome-icon class="ml-2 mr-2" :icon="['fas', 'lock']" size="2xl"/>
            <span class="h4"> Managers and Observer Only </span>
          </b-form-radio>
          <b-row class="ml-3 mb-2">
            <b-col class="ml-3" lg="11" sm="11">
              Data will only be visible to project managers and the member who
              submitted the observation. All questions in this datasheet will
              become private.
            </b-col>
          </b-row>
        </b-form-radio-group>
      </template>
      <template #modal-footer>
        <span class="mr-5">Save the Datasheet to apply this change</span>
        <b-button size="md" variant="primary" @click="handleOk()">
          Done
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    projectPrivacy: {
      type: Boolean,
      required: true,
      default: false,
    },
    datasheetPrivacy: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isPrivate: false,
      cascadePublic: false,
    };
  },
  created() {
    this.isPrivate = this.datasheetPrivacy;
  },
  watch: {
    datasheetPrivacy(newVal, oldVal) {
      if (newVal) {
        this.isPrivate = newVal;
      }
    },
    isPrivate(newVal) {
      if (newVal) {
        this.cascadePublic = false;
      }
    },
  },
  methods: {
    handleOk() {
      if (this.isPrivate) {
        this.$emit("changeDatasheetToPrivate");
      } else {
        this.$emit("changeDatasheetToPublic", this.cascadePublic);
      }
      this.$nextTick(() => {
        this.$bvModal.hide("datasheet-privacy-modal");
      });
    },
  },
};
</script>

<style scoped>
.privacy-modal {
  background-color: rgb(248, 230, 208) !important;
}
</style>
